import { render, staticRenderFns } from "./WidgetInstructionsTwo.vue?vue&type=template&id=5999fc12&"
import script from "./WidgetInstructionsTwo.vue?vue&type=script&lang=js&"
export * from "./WidgetInstructionsTwo.vue?vue&type=script&lang=js&"
import style0 from "./WidgetInstructionsTwo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports